import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

const CustomCircularProgress = (props) => {
  const { primary, ...other } = props;
  const themeContext = useContext(ThemeContext);
  const StyledCircularProgress = withStyles({
    root: {
      color: primary ?
        `${themeContext.buttons.color.primaryColor}` :
        `${themeContext.buttons.color.secondaryColor}`,
      marginRight: '10px',
    },
  })(CircularProgress);

  return (
    <>
      <StyledCircularProgress {...other} />
    </>
  );
};

CustomCircularProgress.propTypes = {
  primary: PropTypes.bool,
};

export default (CustomCircularProgress);
